import { Controller } from "stimulus"

export default class extends Controller {
  toggle(event) {
    const open = document.getElementById('nav-links').classList.toggle('active')
    event.currentTarget.setAttribute('aria-expanded', open)
  }
}
